(() => {
  const HASH = '#mobile-buy';
  const MOBILE_MAX = 749;

  function isMobile() {
    return window.matchMedia(`(max-width: ${MOBILE_MAX}px)`).matches;
  }

  function findPrimaryAddToCart() {
    return (
      document.querySelector('.pp-product-information form[data-type="add-to-cart-form"] button[type="submit"][name="add"]') ||
      document.querySelector('.pp-product-information .product-form__submit') ||
      document.querySelector('product-form button[type="submit"][name="add"]') ||
      document.querySelector('form[action*="/cart/add"] button[type="submit"]')
    );
  }

  function scrollToBestBuyPosition() {
    if (!isMobile() || window.location.hash !== HASH) return false;

    const button = findPrimaryAddToCart();
    if (!button) return false;

    const rect = button.getBoundingClientRect();

    /*
      Scroll only as much as necessary to make the full ATC button visible
      near the bottom of the phone. This intentionally preserves the maximum
      amount of product imagery / thumbnails above the product card.
    */
    const desiredBottom = window.innerHeight * 0.90;
    const needed = rect.bottom - desiredBottom;

    if (needed > 0) {
      window.scrollBy({
        top: needed,
        left: 0,
        behavior: 'instant'
      });
    } else if (rect.top < window.innerHeight * 0.50) {
      // If the button is already visible, avoid pulling the page farther down.
      // Keep the current position so shoppers can still see imagery above.
    }

    return true;
  }

  function runWhenReady() {
    if (!isMobile() || window.location.hash !== HASH) return;

    // PagePilot sections can hydrate after DOMContentLoaded, so retry briefly.
    let tries = 0;
    const timer = setInterval(() => {
      tries += 1;
      if (scrollToBestBuyPosition() || tries >= 20) {
        clearInterval(timer);
      }
    }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runWhenReady, { once: true });
  } else {
    runWhenReady();
  }

  window.addEventListener('hashchange', runWhenReady);
  document.addEventListener('shopify:section:load', runWhenReady);
})();
